// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthForm_wrapper__gm9RI","form":"AuthForm_form__no852","title":"AuthForm_title__wkkUi"};